export default function Timeline(element) {
    const dom = {
        root: element,
        drawer: element.querySelector('.timeline__drawer'),
        revealButton: element.querySelector('.timeline__button--reveal'),
    };
    dom.root.classList.add('timeline__container--compact');
    dom.drawer.classList.remove('hidden');
    dom.revealButton.addEventListener('click', () => {
        dom.drawer.classList.add('hidden');
        dom.root.classList.remove('timeline__container--compact');
    });
    return {
        dom,
    };
}
